import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";
const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="erp-integration-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">
            Streamlining Success with Smarter ERP Solutions
          </h4>
          <p className="contact_investers_para">
            At Soori Corporation, our ERP solutions go beyond managing
            operations, they unlock new potential. With cutting-edge technology
            and industry expertise, we streamline workflows, boost
            decision-making, and drive growth, ensuring peak efficiency across
            your business.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Request a demo
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
